import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStream } from '../../hooks/useStream';
import StateService from '../../services/stateService/StateService';
import { useStyles } from './styles';

function Reseller() {
    const classes = useStyles();
    const [t] = useTranslation();
    const [currentRoles, setCurrentRoles] = useStream(StateService.currentRoles$);
    const [rolesPresent, setRolesPresent] = useState(false);
    const [langPath, setLangPath] = useState(localStorage.getItem('language') || 'de');

    useEffect(() => {
        const newLang = localStorage.getItem('i18nextLng');
        setLangPath(newLang || 'de'); // Default to 'de' if no language is found
    }, [localStorage.getItem('i18nextLng')]);

    useEffect(() => {
        if (currentRoles && currentRoles.length > 0) {
            setRolesPresent(currentRoles.length > 0 && currentRoles[0].length > 0);
        }
    }, [currentRoles]);

    return (
        <>
            {rolesPresent && (
                <div className={classes.root} data-testid="online-help">
                    <iframe
                        src={`reseller/${t(`ONLINE_HELP.SUBPATH_LINK_${langPath.toUpperCase()}`)}/index.html`}
                        style={{ height: '100%', width: '100%' }}
                    />
                </div>
            )}
        </>
    );
}

export default Reseller;
